<template>
  <div
    style="
      background: var(--v-backgroundColor-base);
      padding: 10px;
      border-radius: 4px;
      display: flex;
      flex-wrap: wrap;
      align-content: start;
    ">
    <TagsViewer
      :editMode="true"
      :filterByTag="userEditObj.tags"
      :tags="Object.values(deluge.tags)"
      @select="handle_tag_click"
      @newTag="on_new_tag"
      :selectable="true"
      :showAddButton="true"
      :tagContainerHeight="true" />
  </div>
</template>
<script setup>
import { $http } from '../../../stores/http';
import { deluge } from '../../../stores/deluge';
import TagsViewer from '../../Shared/TagsViewer.vue';

const props = defineProps(['userEditObj']);

function handle_tag_click(tag) {
  if (props.userEditObj.tags.includes(tag.uid)) {
    remove_tag(tag.uid);
  } else {
    add_tag_to_template(tag.uid);
  }
}

async function add_tag_to_template(tag_id) {
  try {
    await $http(
      'PUT',
      '/add_tag_to_template?tag_uid=' +
        tag_id +
        '&template_uid=' +
        props.userEditObj.uid
    );
    props.userEditObj.tags.push(tag_id);
  } catch (error) {
    console.log(error);
  }
}
async function remove_tag(tag_id) {
  try {
    await $http(
      'PUT',
      '/remove_tag_from_template?tag_uid=' +
        tag_id +
        '&template_uid=' +
        props.userEditObj.uid
    );
    props.userEditObj.tags = props.userEditObj.tags.filter(
      (tag) => tag !== tag_id
    );
  } catch (error) {
    console.log(error);
  }
}

// Auto-select newly created tags
async function on_new_tag(newTagObj) {
  if (newTagObj?.uid && !props.userEditObj.tags.includes(newTagObj.uid)) {
    await add_tag_to_template(newTagObj.uid);
  }
}
</script>
